import owners, { OwnersFilterState as OFState } from './owners';
import projects, { ProjectsFilterState as PFState } from './projects';
import workspaces, { WorkspacesFilterState as WFState } from './workspaces';

export { owners, projects, workspaces };

export type OwnersFilterState = OFState; // TODO: P2X-920 Remove explicitly stated type
export type ProjectsFilterState = PFState; // TODO: P2X-920 Remove explicitly stated type
export type WorkspacesFilterState = WFState; // TODO: P2X-920 Remove explicitly stated type
